import React from 'react'
import { FormattedMessage } from 'react-intl'

const minLongitude = -180
const maxLongitude = 180

export default class IsLongitude {
  constructor({ value }) {
    this.value = value
    this.errorMessage = <FormattedMessage id="invalid_longitude" />
  }

  validate() {
    const { value } = this

    if (value < minLongitude || value > maxLongitude) {
      return this.errorMessage
    }

    return null
  }
}
